module.exports = __webpack_public_path__ + "img/3.05.thmb.xs.77b61100.jpg";